import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { easeInOut } from '../utils/curves';
import { largeDurationMs } from '../utils/durations';
import KeyframesMotion from './keyframes-motion';
const entranceMotions = {
  bottom: 'translate3d(0, calc(5% + 4px), 0)',
  left: 'translate3d(calc(-5% - 4px), 0, 0)',
  right: 'translate3d(calc(5% + 4px), 0, 0)',
  top: 'translate3d(0, calc(-5% - 4px), 0)'
};
const exitMotions = {
  bottom: 'translate3d(0, calc(-5% - 4px), 0)',
  left: 'translate3d(calc(5% + 4px), 0, 0)',
  right: 'translate3d(calc(-5% - 4px), 0, 0)',
  top: 'translate3d(0, calc(5% + 4px), 0)'
};
export const fadeInAnimation = movement => {
  return {
    from: {
      opacity: 0,
      ...(movement !== undefined && {
        transform: entranceMotions[movement]
      })
    },
    '50%': {
      opacity: 1
    },
    to: {
      transform: movement !== undefined ? 'none' : undefined
    }
  };
};
export const fadeOutAnimation = movement => ({
  from: {
    opacity: 1,
    transform: movement !== undefined ? 'translate3d(0, 0, 0)' : undefined
  },
  to: {
    opacity: 0,
    ...(movement !== undefined && {
      transform: exitMotions[movement]
    })
  }
});
/**
 * Props for controlling the behaviour of the FadeIn animation
 */

const FadeIn = ({
  children,
  duration = largeDurationMs,
  entranceDirection: entranceSlideDirection,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(KeyframesMotion, _extends({
    duration: duration,
    enteringAnimation: fadeInAnimation(entranceSlideDirection),
    exitingAnimation: fadeOutAnimation(entranceSlideDirection),
    animationTimingFunction: () => easeInOut
  }, props), children);
};

export default FadeIn;